import { axiosInstance } from '@/rest'

const buildSearchParams = (params = {}) => {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v))
    } else {
      searchParams.append(key, value)
    }
  })
  return searchParams
}

const createSubAccountsApi = () => {
  return {
    /**
     * List sub-accounts with optional filters
     * @param {Object} params { account_number, role, active, self_directed, limit, offset,
     *   order_by: 'sub_account_number' | 'newsletter_name',
     *   sort_direction: 'asc' | 'desc' }
     */
    list: (params = {}) => {
      const searchParams = buildSearchParams(params)
      return axiosInstance.get(`v2/subaccounts?${searchParams.toString()}`)
    },

    /**
     * Create a sub-account
     * @param {Object} body { account_number, sub_account_name, self_directed, role }
     */
    create: (body) => axiosInstance.post(`v2/subaccounts`, body),

    /**
     * Partially update a sub-account
     * @param {string} subAccountId
     * @param {Object} body { sub_account_name, self_directed, active }
     */
    update: (subAccountId, body) =>
      axiosInstance.patch(`v2/subaccounts/${subAccountId}`, body),

    /**
     * Subscribe a sub-account to a newsletter
     * @param {Object} body {
     *   sub_account_id, newsletter_id,
     *   stock_signals_enabled, stock_max_dollar_allocation, stock_max_shares,
     *   stock_all_or_none, stock_round_lots_only, stock_multiplier,
     *   option_signals_enabled, option_max_dollar_allocation, option_max_contracts,
     *   option_all_or_none, option_multiplier
     * }
     */
    createSubscription: (body) =>
      axiosInstance.post(`v2/subaccounts/newsletter-subscriptions`, body),

    /**
     * Partially update allocation fields on a subscription
     * (sub_account_id and newsletter_id are immutable)
     * @param {string} subscriptionId
     * @param {Object} body allocation fields (at least one required)
     */
    updateSubscription: (subscriptionId, body) =>
      axiosInstance.patch(
        `v2/subaccounts/newsletter-subscriptions/${subscriptionId}`,
        body
      ),

    /**
     * Delete a newsletter subscription
     * @param {string} subscriptionId
     */
    deleteSubscription: (subscriptionId) =>
      axiosInstance.delete(
        `v2/subaccounts/newsletter-subscriptions/${subscriptionId}`
      ),
  }
}

const subAccountsApi = createSubAccountsApi()

export { subAccountsApi }
